// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"2879e5dc","343":"c41a892d","453":"73234c1e"}[chunkId] + ".chunk.js";
};